import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditTLO,
} from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { usePortfolio } from "web/hooks/data"
import React, { Suspense } from "react"

export default class PortfolioViewOrEditTLOController extends Controller {
  static values = {
    portfolioId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const PortfolioTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="portfolio"
          data={usePortfolio(this.portfolioIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <PortfolioTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditTLO />
                </ErrorBoundary>
              </PortfolioTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
